import React, { useRef } from "react";
import { Loader2, Paperclip, X } from "lucide-react";

export const AttachButton = ({ onFiles, disabled, testid }) => {
  const input = useRef(null);
  return (
    <>
      <input ref={input} type="file" accept="image/*" multiple hidden data-testid={`${testid}-input`}
        onChange={(e) => { onFiles(e.target.files); e.target.value = ""; }} />
      <button type="button" onClick={() => input.current?.click()} disabled={disabled} data-testid={testid}
        title="Attach screenshots or designs" aria-label="Attach images"
        className="w-9 h-9 shrink-0 rounded-full text-slate-600 hover:bg-slate-100 flex items-center justify-center transition-colors disabled:opacity-40">
        <Paperclip size={18} strokeWidth={1.8} />
      </button>
    </>
  );
};

export const AttachmentTray = ({ items, onRemove, testid = "attachment" }) => {
  if (!items.length) return null;
  return (
    <div className="flex flex-wrap gap-2 pb-2" data-testid={`${testid}-tray`}>
      {items.map((x, i) => (
        <div key={x.key} className="relative w-14 h-14 rounded-xl overflow-hidden ring-1 ring-slate-200 bg-slate-50 fade-up" data-testid={`${testid}-item-${i}`}>
          <img src={x.preview} alt={x.name} className="w-full h-full object-cover" />
          {!x.id && (
            <div className="absolute inset-0 bg-white/75 flex flex-col items-center justify-center text-[10px] font-mono text-sky-700">
              <Loader2 size={12} className="animate-spin" />{x.progress}%
            </div>
          )}
          <button type="button" onClick={() => onRemove(x.key)} data-testid={`${testid}-remove-${i}`} aria-label="Remove image"
            className="absolute top-0.5 right-0.5 w-4 h-4 rounded-full bg-slate-900/80 text-white flex items-center justify-center hover:bg-rose-600">
            <X size={10} />
          </button>
        </div>
      ))}
    </div>
  );
};
